import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconStackHorizontalAltTwo20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconStackHorizontalAltTwo20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M3.5 6.5h3a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1v-5a1 1 0 0 1 1-1M1 7.5A2.5 2.5 0 0 1 3.5 5h3A2.5 2.5 0 0 1 9 7.5v5A2.5 2.5 0 0 1 6.5 15h-3A2.5 2.5 0 0 1 1 12.5zm12.5-1h3a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1v-5a1 1 0 0 1 1-1m-2.5 1A2.5 2.5 0 0 1 13.5 5h3A2.5 2.5 0 0 1 19 7.5v5a2.5 2.5 0 0 1-2.5 2.5h-3a2.5 2.5 0 0 1-2.5-2.5z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconStackHorizontalAltTwo20);
